import { createSlice } from 'redux-starter-kit';
import apiClient from '../Api/api_client';
import { loadingSlice } from './LoadingStore';

export const feedbackCategories = {
    feedbackCategories: {},
};

// REDUCERS
// basic actions that affect this object only

const getFeedbackCategoriesReducer = (state, action) => {
    return {
        feedbackCategories: action.payload,
    };
};

export const feedbackCategoriesSlice = createSlice({
    name: 'feedbackCategories',
    initialState: feedbackCategories,
    reducers: {
        getFeedbackCategories: getFeedbackCategoriesReducer,
    },
});

//ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const getFeedbackCategories = async (dispatch, payload) => {
    dispatch(loadingSlice.actions.setLoading({ action: 'getFeedbackCategories' }));
    const result = await apiClient().getFeedbackCategories(payload);
    dispatch(feedbackCategoriesSlice.actions.getFeedbackCategories(result));
    dispatch(loadingSlice.actions.unsetLoading({ action: 'getFeedbackCategories' }));
};

//actions that get exported to the views
export const feedbackCategoriesActions = dispatch => {
    return {
        getFeedbackCategories: payload => getFeedbackCategories(dispatch, payload),
    };
};
